import utils from 'utils';

class stampDutyreportQueryCtrl {
  constructor(
    $scope,
    logger,
    httpRequest,
    $state,
    sweetalert,
    initSortService,
    $filter
  ) {
    $scope.currentUserInfo = JSON.parse(localStorage.user_info).user;
    $scope.select = {}
    $scope.treeConfig = {
        isCheckall: true,
        check: {
            //如果没有设置配置项，取默认配置
            enable: true, //显示不显示复选框
            chkboxType: { Y: '', N: '' },
        },
    }
    // 上月的第一天和最后一天
    const obj = utils.getLastMonthFirstLast();
    $scope.applyPeriodStart = obj.lastDayOfPreMonth;
    // 查询条件
    $scope.param = {
      pageNum: 1,
      pageSize: 10,
      param: {
        amountOrNumber: '',
        companyName: '',
        currentTaxPayable: '',
        currentTaxRefund: '',
        id: '',
        taskId: '',
        taxNo: '',
        taxPaid: '',
        taxRate: '',
        taxableCertificate: '',
        taxpayerReduction: '',
        applyPeriodStart: obj.firstDayOfPreMonth,
        applyPeriodEnd: obj.lastDayOfPreMonth,
      },
    };
    // 重置
    $scope.reset = function reset() {
      $scope.param.param = {
        amountOrNumber: '',
        companyName: '',
        currentTaxPayable: '',
        currentTaxRefund: '',
        id: '',
        taskId: '',
        taxNo: '',
        taxPaid: '',
        taxRate: '',
        taxableCertificate: '',
        taxpayerReduction: '',
        applyPeriodStart: obj.firstDayOfPreMonth,
        applyPeriodEnd: obj.lastDayOfPreMonth,
      };
    //   $scope.queryTaxInfo();
    getUserInfo()
    };
    $scope.datePickerConfig = {
      clearBtn: true, //清除按钮
      // todayBtn: true,
    };
    // // 清空操作
    // $scope.clearTime = function (val) {
    //   // console.log(val)
    //   if (val == 2) {
    //     $scope.param.param.applyPeriodStart = ''
    //   } else if (val == 12) {
    //     $scope.param.param.applyPeriodEnd = ''
    //   } else {
    //     console.log(val)
    //   }
    // }
    // 字典字段
    $scope.dictionary = {};
    const typeCodeArr = [
      'stamp_duty_taxable_certificate', //凭证
      'department_no', //事业部
      'stamp_duty_reporting_period', //申报周期
    ];
    httpRequest.get_dictByTypeArr(typeCodeArr).then((res) => {
      $scope.dictionary = $.extend($scope.dictionary, res.data.value);
    });
    // 主管税局所在省市
    httpRequest
      .get_getAllTaxBureau(localStorage.getItem('id_token'))
      .then((res) => {
        $scope.dictDataProvince = res.data.value;
      });
    // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
    httpRequest.get_getBelleRegion().then((res) => {
      $scope.belleRegionList = res.data.value;
    });
    // 获取管理城市时两个都要传
    $scope.$watch('param.param.regionName', function (newVal, oldVal) {
      //重置
      if ($scope.param.param.regionName == undefined) {
        $scope.belleRegionCityList = [];
        return;
      }
      // 查询值
      angular.forEach($scope.dictionary.department_no, function (item, index) {
        if (item.enumName === $scope.param.param.departmentNo) {
          $scope.departmentNo = item.enumCode;
        }
      });
      angular.forEach($scope.belleRegionList, function (item, index) {
        if (item.regionName === newVal) {
          $scope.regionNo = item.treeLevelCode;
        }
      });
      let params = {
        affiliation: $scope.departmentNo,
        regionNo: $scope.regionNo,
      };
      if (params.affiliation == '' || params.regionNo == '') return;
      httpRequest.get_getBelleRegion(params).then((res) => {
        $scope.belleRegionCityList = res.data.value;
      });
    });
    // 初始化查询和表格控件实例
    $scope.customizedConfig = {
      version: 1.3,
      queryConfig: [
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '应税凭证',
          selected: true,
          default: true,
        },
        {
          label: '税款所属期起',
          selected: true,
          default: true,
        },
        {
          label: '税款所属期止',
          selected: true,
          default: true,
        },
        {
          label: '计税金额或件数',
          selected: false,
          default: false,
        },
        {
          label: '适用税率',
          selected: false,
          default: false,
        },
        {
          label: '本期应纳税额',
          selected: false,
          default: false,
        },
        {
          label: '本期已缴税额',
          selected: false,
          default: false,
        },
        {
          label: '增值税小规模纳税人减征额',
          selected: false,
          default: false,
        },
        {
          label: '本期应补（退）税额',
          selected: false,
          default: false,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省市',
          selected: false,
          default: false,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '申报周期',
          selected: false,
          default: false,
        },
        {
          label: '跟进人',
          selected: false,
          default: false,
        },
      ],
      table: [
        {
          label: '纳税人识别号',
          selected: true,
          default: true,
        },
        {
          label: '纳税人名称',
          selected: true,
          default: true,
        },
        {
          label: '应税凭证',
          selected: true,
          default: true,
        },
        {
          label: '税款所属期起',
          selected: true,
          default: true,
        },
        {
          label: '税款所属期止',
          selected: true,
          default: true,
        },
        {
          label: '计税金额或件数',
          selected: true,
          default: true,
        },
        {
          label: '适用税率',
          selected: true,
          default: true,
        },
        {
          label: '本期应纳税额',
          selected: true,
          default: true,
        },
        {
          label: '本期已缴税额',
          selected: false,
          default: false,
        },
        {
          label: '增值税小规模纳税人减征额',
          selected: true,
          default: true,
        },
        {
          label: '本期应补（退）税额',
          selected: true,
          default: true,
        },
        {
          label: '事业部',
          selected: false,
          default: false,
        },
        {
          label: '所属大区',
          selected: false,
          default: false,
        },
        {
          label: '主管税局所在省市',
          selected: false,
          default: false,
        },
        {
          label: '申报表下载',
          selected: true,
          default: true,
        },
        {
          label: '管理城市',
          selected: false,
          default: false,
        },
        {
          label: '申报周期',
          selected: false,
          default: false,
        },
        {
          label: '跟进人',
          selected: false,
          default: false,
        },
      ],
    };
    // 查询列表
    $scope.queryTaxInfo = function () {
      const openLoading =
        $scope.param.pageSize >= 100
          ? window.layer.msg('正在查询，请耐心等待', {
              time: 0,
              skin: 'layer-loading-self',
              icon: 16,
              shade: 0.5,
            })
          : null;
      httpRequest
        .post_getRpaStampDutyResultDtoList(queryDataHandle($scope.param))
        .then((res) => {
          $scope.listData = res.data.value.list;
          // 获取后台分页数据 回写分页组件
          $scope.totalItems = res.data.value.total; //
          $scope.param.pageNum = res.data.value.pageNum;
          $scope.param.pageSize = res.data.value.pageSize;
          // 查询之后清空已经选择的数据
          $scope.selectedRows = [];
        })
        .finally(() => {
          window.layer.close(openLoading);
        });
    };
    function queryDataHandle(queryData) {
        $scope.employeeList = []
        const { selectedFollower } = $scope.select
        selectedFollower.forEach(item => {
            $scope.employeeList.push({employeeName:item.employeeName, employeeNumber:item.employeeNumber})
        });
        queryData.param.employeeList = $scope.employeeList

        return queryData
    }
    $scope.searchList = function () {
      $scope.queryTaxInfo();
    };
    // $scope.queryTaxInfo();
    // 分页
    $scope.pageChanged = function () {
      // 点击页码发起查询
      $scope.queryTaxInfo();
    };
    $scope.totalItems = 0; // 组件初始化设置总页数
    //导出
    $scope.exportExel = function exportExel() {
      let fileName = '印花税申报表查询_' + utils.getNowDate().nowDate;
      let url = `${
        host.etcloudIvatApp
      }taxdeclaration/rpaGsTask/exportList?accessToken=${localStorage.getItem(
        'id_token'
      )}`;
      utils.file_download(
        url,
        $scope.param.param,
        'stampduty_result', //type
        'POST',
        'blob',
        fileName,
        false
      );
    };
    //单个下载
    $scope.downloadFile = function (data) {
      if (data.mongoId == null) {
        logger.logError('申报表附件暂未生成，请稍后重试');
        return;
      }
      if (
        Number(data.declarationStatus) != 2 &&
        Number(data.declarationStatus) != 3
      ) {
        logger.logError(
          '申报状态为“申报成功”或"人工申报成功"的报表才允许下载，请检查'
        );
        return;
      }
      let url = `${host.etcloudIvatApp}taxdeclaration/rpaStampDutyResult/downSbFile`;
      let params = {
        sbDownListDtos: [
          {
            mongoId: data.mongoId,
            id: data.id,
            applyperiod: '',
            taxNo: data.taxNo,
          },
        ],
      };
      let fileName = data.fileName;
      utils.declarefile_download(url, fileName, 'POST', 'blob', params, false);
    };
    // 批量下载
    $scope.batchDownload = function () {
      if (!$scope.selectedRows.length) {
        return logger.logError('请选择数据后操作');
      }
      // 可下载的集合
      $scope.newSelectedRows = [];
      angular.forEach($scope.selectedRows, function (item, index) {
        if (
          (Number(item.declarationStatus) == 2 ||
            Number(item.declarationStatus) == 3) &&
          item.mongoId != null
        ) {
          $scope.newSelectedRows.push(item);
        }
      });
      if ($scope.newSelectedRows.length == 0) {
        logger.logError('选择的数据暂时没有附件或申报状态不符合，请检查');
        return;
      }
      //选择一个的时候单个下载
      if ($scope.newSelectedRows.length == 1) {
        $scope.downloadFile($scope.newSelectedRows[0]);
        return;
      }
      // 相同数据 附件一样合并处理
      $scope.mergingList = $scope.taxDataMerging($scope.newSelectedRows);
      let applyPeriod = obj.lastDayOfPreMonth.substring(
        0,
        obj.lastDayOfPreMonth.length - 3
      );
      let resetFileName = '纳税申报表' + applyPeriod.replace('-', '');
      let params = {
        enclosure: resetFileName,
        sbDownListDtos: $scope.mergingList,
      };
      let url = `${host.etcloudIvatApp}taxdeclaration/rpaStampDutyResult/downSbFile`;
      utils.declarefile_download(
        url,
        resetFileName,
        'POST',
        'blob',
        params,
        true
      );
    };
    // 数据合并处理 函数封装
    $scope.taxDataMerging = function (arr) {
      let newArr = [];
      arr.forEach((item) => {
        let dataItem = item;
        if (newArr.length > 0) {
          let filterValue = newArr.filter((v) => {
            return v.mongoId == dataItem.mongoId;
          });
          if (filterValue.length > 0) {
            // 相同处理
            newArr.forEach((n) => {
              if (n.mongoId == filterValue[0].mongoId) {
                n.id = dataItem.id;
                n.mongoId = dataItem.mongoId;
              }
            });
          } else {
            let newDataItem = {
              id: dataItem.id,
              mongoId: dataItem.mongoId,
            };
            newArr.push(newDataItem);
          }
        } else {
          let newDataItem = {
            id: dataItem.id,
            mongoId: dataItem.mongoId,
          };
          newArr.push(newDataItem);
        }
      });
      return newArr;
    };
    function getUserInfo() {
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.get_getIvatEmployeeList().then((res) => {
            $scope.followerList = dataHandle(res.data.value)
            $scope.select.selectedFollower =  $scope.followerList.filter((x) => { return x.employeeName == $scope.currentUserInfo.realName})
            $scope.queryTaxInfo()
        })
    }
    getUserInfo()
    function dataHandle(list) {
        list.forEach((el,index) => {
            el.orgId = index
            el.orgName = el.employeeName + '|' + el.employeeNumber
            if ($scope.currentUserInfo.realName == el.employeeName) {
                el.checked = true
            } else {
                el.checked = false
            }
        })
        return list
    }
  }
}

stampDutyreportQueryCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  '$state',
  'sweetalert',
  'initSortService',
  '$filter',
];
export default stampDutyreportQueryCtrl;



// WEBPACK FOOTER //
// ./src/app/declaration/stampDuty/stampDutyreportQuery/stampDutyreportQueryCtrl.js